
<template>
  <div>

      <form v-if="currentUser != null" action="/" ref="" @submit.prevent="formSubmit()">
        <div class="modal-card" style="width: 300px; margin: 0 auto;">
            <header class="modal-card-head">
                <p class="modal-card-title">Get specification</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Phone number">
                    <b-input
                        type="text" 
                        :disabled="detailsPhone"
                        @input="user.phone = $event"
                        v-bind:value="detailsPhone"
                        placeholder="Your phone number"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Email">
                    <b-input
                        type="email"
                        @input="user.email = $event"
                        v-bind:value="detailsEmail"
                        :disabled="detailsEmail"
                        placeholder="Your email"
                        required>
                    </b-input>
                </b-field>

       
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" :disabled="allDetailsEmpty" @click="handleSignoutClick()">Forget me</button>
                        <button class="button is-outlined is-primary" :disabled="!isAuthenticated || isLoading">Send</button>
                    </footer>
                </div>
            </form>
            
           

  </div>
</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";
  import {db} from '@/services/db'
  import firebase from 'firebase/app'
  import 'firebase/auth';
   
  export default {

    name: 'RequestForm',
    props: ['order'],

    data(){
      return {
        user:{
          email:null,
          phone: null
        },
        isLoading:false

      }
    },

    computed:{
      
      
      ...mapGetters(['isAuthenticated','currentUser' ]),

      detailsName(){
        return (this.currentUser.hasOwnProperty('details') && this.currentUser.details.hasOwnProperty('name'))?this.currentUser.details.name:null;
      },
      detailsPhone(){
        return (this.currentUser.hasOwnProperty('details') && this.currentUser.details.hasOwnProperty('phone'))?this.currentUser.details.phone:null;
      },
      detailsEmail(){
        return (this.currentUser.hasOwnProperty('details') && this.currentUser.details.hasOwnProperty('email'))?this.currentUser.details.email:null;
      },
      allDetailsEmpty(){
        return this.detailsEmail === null && this.detailsPhone === null;
      }
    },
 
    methods : {

      ...mapActions(['userSignout', 'UPDATE_USER_DETAILS']),

 
      createOrder(){

        this.isLoading = true;
        
        this.$store.dispatch("createOrder", {order:this.order, user:this.user}).then(response => {
          this.isLoading = false;
            this.$parent.close();
            this.$router.push(response.path);
        }, error => {
            console.error("Got nothing from server.", error)
        });
      },

      handleSignoutClick(){
        this.$buefy.dialog.confirm({
              title: 'Forget account',
              message: 'Are you sure you want to <b>delete</b> your temporary guest account? You will lose access to previously created orders.',
              confirmText: 'Remove me',
              type: 'is-danger',
              iconPack:'fas',
              hasIcon: true,
              onConfirm: () => this.userSignout()
          })
      },

      formSubmit(e){

        
   
          for (var propName in this.user) { 
            if (this.user[propName] === null || this.user[propName] === undefined) {
              delete this.user[propName];
            }
          }

          this.createOrder();
           
      }

  }

  }
    
</script>

<style scoped>

  .modal-card{
    text-align: left;
  }

</style>
